<template>
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="56"
      height="56"
      rx="8"
      fill="var(--gray50)"
    />
    <path
      d="M37.4109 21.7019C36.1988 21.1934 34.9857 21 33.7732 21C29.9242 20.9997 26.0755 22.9481 22.2265 22.9481C21.2612 22.9481 20.2965 22.8256 19.3312 22.5194C19.2228 22.485 19.114 22.4688 19.0078 22.4688C18.47 22.4688 18 22.885 18 23.4628V33.3772C18 33.7719 18.2259 34.1459 18.5887 34.2978C19.8009 34.8066 21.014 35 22.2265 35C26.0755 35 29.9245 33.0516 33.7735 33.0516C34.7388 33.0516 35.7035 33.1741 36.6688 33.4803C36.7772 33.5147 36.886 33.5309 36.9922 33.5309C37.53 33.5309 38 33.1147 38 32.5369V22.6228C37.9997 22.2278 37.7738 21.8541 37.4109 21.7019ZM19.5 24.1319C20.1287 24.2894 20.785 24.3684 21.4599 24.4109C21.2762 25.3294 20.4687 26.0216 19.5 26.0216V24.1319ZM19.5 33.0381V31.545C20.574 31.545 21.4431 32.3972 21.4909 33.4637C20.7868 33.4072 20.1287 33.2666 19.5 33.0381ZM27.9998 31C26.6189 31 25.4999 29.6566 25.4999 28C25.4999 26.3431 26.6192 25 27.9998 25C29.3804 25 30.4998 26.3431 30.4998 28C30.4998 29.6572 29.3801 31 27.9998 31ZM36.4997 31.8681C35.9522 31.7309 35.3838 31.6541 34.8022 31.6044C34.9857 30.7894 35.6616 30.1706 36.4997 30.0644V31.8681ZM36.4997 24.4897C35.5344 24.3675 34.7854 23.5616 34.7557 22.5663C35.3663 22.6341 35.946 22.7609 36.4997 22.9619V24.4897Z"
      fill="var(--systemSuccess)"
    />
  </svg>
</template>